import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as User from './../helpers/User';
const $=window.$;

//const $=window.$;
// const win=window;

class MyJourneyLists extends Component {
	constructor(props) {
		super(props);
        this.state={
        };

	}

	fnChange(e){
    let tabdiv=e;
					if($('.'+tabdiv+':visible').length == 0)
					{
							$("."+tabdiv).show();
					} else {
						$("."+tabdiv).hide();
					}
  }
	switchComponentPanel(type,lr_id,dlr_id){
		const {view_type} = this.props;
		if(view_type=='webview'){
			return false;
		}
		else{
	 		this.props.getLrinfo(type,lr_id,dlr_id);
		}

	}

		render() {

			let lrcomponents=null;
			if($.isArray(this.props.tabsdata)){
			 lrcomponents=this.props.tabsdata.map((key,index)=>{
            return <div key={`lrroom-head${index}`}>
						<div key={`main-lrroom-div${index}`} className="newtb tablehide" id="para" onClick={(e) =>this.fnChange('tablejourney'+index)}> <img title="" alt="" src={process.env.PUBLIC_URL+"/images/downarrow.png"} />{key} </div>
						<div key={`lrroom-div${index}`} className={`tablejourney${index} tabcls divv divhide tableshow`} id="div1" style={{display:'none'}}>
							<div key={`lrroom-colum${index}`} className="my-journey-table-content fivecolumns newtb">
								<table key={`lrroom-table${index}`}  style={{width:'100%'}} className="myjourney-table mytb ">

									{this.props.tabsdatalist[index].map((val,ind)=>{
										return <tbody key={`lrroom-tbody${ind}`}>
										<tr key={`lrroom-tr${ind}`} className="oddbg">
											<td className={(this.props.tabsdatalist[index].length==ind+1)?"lreach10lasettr":""} key={`lrroom-lrroom-td1${ind}`} style={{width:'13%'}}><a key={`a-lrroom-lrroom-td1${ind}`} onClick={e=>this.switchComponentPanel('componet_list',val['lr_id'],0)} href="javascript:void(0);" title={val['rooms']}>{val['rooms']}</a></td>
											<td className={(this.props.tabsdatalist[index].length==ind+1)?"lreach10lasettr":""} key={`lrroom-td2${ind}`} style={{width:'34%'}}>{val['room_name']}</td>
											<td className={(this.props.tabsdatalist[index].length==ind+1)?"lreach10lasettr":""} key={`lrroom-td3${ind}`} style={{width:'22.5%'}}>{val['module_name']}</td>

											{/* <td key={`lrroom-td4${ind}`} style={{width:'20.5%'}}><p dangerouslySetInnerHTML={{ __html:val['pscore']?val['pscore']:''}} /></td> */}
											<td className={(this.props.tabsdatalist[index].length==ind+1)?"lreach10lasettr":""} key={`lrroom-td5${ind}`} style={{}}><img src={process.env.PUBLIC_URL+"/images/"+val['status']+".png"} width="15" height="15" alt="" border="0" className="tick" /></td>
										</tr>
										 </tbody>
								})
							}
								</table>
							</div>
						</div>
						</div>
        });
			}
			/*
			let lrmodulewise=null;
			
			if($.isArray(this.props.lrmodule)){
				 lrmodulewise=this.props.lrmodule.map((key,index)=>{
	            return <div key={`lrmodule-head${index}`}>
							<div key={`main-lrmodule-div${index}`} className="tablehide" id="para" onClick={(e) =>this.fnChange('tablejourney1'+index)}> <img title="" alt="" src={process.env.PUBLIC_URL+"/images/downarrow.png"} />{key} </div>
							<div key={`lrmodule-div${index}`} className={`tablejourney1${index} tabcls divv divhide tableshow`} id="div1" style={{display:'none'}}>
								<div key={`lrmodule-colum${index}`} className="my-journey-table-content fivecolumns">
									<table key={`lrmodule-table${index}`}   style={{width:'100%'}} className="myjourney-table">
									<tbody>
										{this.props.lrmodulewiselist[index].map((val,ind)=>{
												return(<tr key={`lrmodule-tr${ind}`} className="oddbg">
															<td key={`lrmodule-td1${ind}`} style={{width:'11%'}}><a onClick={e=>this.switchComponentPanel('componet_list',val['lr_id'],0)} href="javascript:void(0);" title={val['lrmwid']}>{val['lrmwid']}</a></td>
															<td key={`lrmodule-td2${ind}`} style={{width:'34%'}}>{val['lrmwroomname']}</td>
															<td key={`lrmodule-td3${ind}`} style={{width:'20.5%'}}><p dangerouslySetInnerHTML={{ __html:val['lrmwpscore']?val['lrmwpscore']:''}} /></td>
															<td key={`lrmodule-td4${ind}`} style={{}}><img src={process.env.PUBLIC_URL+"/images/"+val['status']+".png"} width="15" height="15" alt="" border="0" className="tick" /></td>
														</tr>)
													})
										}
										</tbody>
								</table>
								</div>
							</div>
							</div>
	        });
				}
				*/
				let dlrroomwise=null;
				if($.isArray(this.props.dlrroomwiselist)) {
				 dlrroomwise = this.props.dlrroomwiselist.map((dlrroom,key)=>{
					return (<tr className={(this.props.dlrroomwiselist.length==key+1)?"lreach10lasettr":""} key={`dlrroom-tr${key}`} className='oddbg'>
									<td className={(this.props.dlrroomwiselist.length==key+1)?"lreach10lasettr":""} key={`dlrroom-td1${key}`} style={{width:'13%'}}><a onClick={e=>this.switchComponentPanel('componet_list',dlrroom['template_dlr_id'],dlrroom['dlr_dlr_id'])} href="javascript:void(0);" title={`Go to DLR ${dlrroom['dlr_id']}`}>ID  {dlrroom['dlr_id']}</a></td>
									<td className={(this.props.dlrroomwiselist.length==key+1)?"lreach10lasettr":""} key={`dlrroom-td2${key}`} style={{width:'34.2%'}}>{dlrroom['dlr_name']}</td>
									<td className={(this.props.dlrroomwiselist.length==key+1)?"lreach10lasettr":""} key={`dlrroom-td3${key}`} style={{width:'22.2%'}}>{dlrroom['module_name']}</td>

									{/* <td key={`dlrroom-td4${key}`} style={{width:'20.4%'}}><p dangerouslySetInnerHTML={{ __html:dlrroom['pscore']?dlrroom['pscore']:''}} /></td> */}
									<td className={(this.props.dlrroomwiselist.length==key+1)?"lreach10lasettr":""} key={`dlrroom-td5${key}`} style={{}}><img src={process.env.PUBLIC_URL+"/images/"+dlrroom['status']+".png"} width="15" height="15" alt="" border="0" className="tick" /></td>
								</tr>)
				});
			}

			//const dlr_module_list='';
			/*
			let dlr_module_list=null;
			if($.isArray(this.props.dlr_module_name_list)) {
				 dlr_module_list=this.props.dlr_module_name_list.map((key,index)=>{
	            return <div key={`dlrmodule-head${index}`}>
							<div key={`main-dlrmodule${index}`} className="tablehide" id="para" onClick={(e) =>this.fnChange('tablejourney2'+index)}> <img title="" alt="" src={process.env.PUBLIC_URL+"/images/downarrow.png"} />{key} </div>
							<div key={`dlrmodule-div${index}`} className={`tablejourney2${index} tabcls divv divhide tableshow`} id="div1" style={{display:'none'}}>
								<div key={`dlrmodule-colum${index}`} className="my-journey-table-content fivecolumns">
									<table key={`dlrmodule-table${index}`} style={{width:'100%'}} className="myjourney-table">

										{this.props.dlrroomwise_array_list[index].map((val,ind)=>{
											return <tbody key={`dlrmodule-tr${ind}`}>
														<tr key={`dlrmodule-tr${ind}`} className="oddbg">
											        <td key={`dlrmodule-td1${ind}`} style={{width:'13%'}}><a onClick={e=>this.switchComponentPanel('componet_list',val['template_dlr_id'],val['dlr_dlr_id'])} href="javascript:void(0);" title={"Go to DLR react1"+val['dlr_id']}>{val['dlr_id']}</a></td>
											        <td key={`dlrmodule-td2${ind}`} style={{width:'33.2%'}}>{val['dlr_name']}</td>

											        <td key={`dlrmodule-td3${ind}`} style={{width:'20.5%'}}><p dangerouslySetInnerHTML={{ __html:val['pscore']?val['pscore']:''}} /> </td>
											        <td key={`dlrmodule-td4${ind}`} style={{}}><img src={process.env.PUBLIC_URL+"/images/"+val['status']+".png"} width="15" height="15" alt="" border="0" className="tick" /></td>
											      </tr>
														</tbody>
									})
								}
									</table>
								</div>
							</div>
							</div>
	        });
				}
				*/
			return (
				//tab class removed resp-tabs-container hor_1
				<div>
							    <div className="resp-tabs-container hor_1">
					          
                            <div className="tab-content" id="room1">
                              
                              <div className="myjourney-tabhead nhead fivecolumns">
                                <div className="headrow  newhead ">
                                  <div className="col">Room no</div>
                                  <div className="col col2">Room Name</div>
                                  <div className="col col3">Module Name</div>

                                  {/* <div className="col col4">PS</div> */}
                                  <div className="col col5">Status</div>
                                </div>
                              </div>

																{lrcomponents}

                            </div>

                                    {/* <div className="teb-content" id="room2">

                                      <div className="abbrevation">
                                        <ul>

                                          <li><strong>PS</strong> - Performance Score</li>
                                          <li><img src={process.env.PUBLIC_URL+"/images/status-completed.png"} alt="" title="" /> - Completed</li>
                                          <li><img src={process.env.PUBLIC_URL+"/images/status-notcompleted.png"} alt="" title="" /> - In Progress</li>
                                          <li><img src={process.env.PUBLIC_URL+"/images/start-small.png"} alt="" title="" /> - Yet to start</li>
                                        </ul>
                                      </div>
                                      <div className="myjourney-tabhead fivecolumns">
                                        <div className="headrow">
                                          <div className="col">Rooms</div>
                                          <div className="col col2">Room Name</div>

                                          <div className="col col4">PS</div>
                                          <div className="col col5">Status</div>
                                        </div>
                                      </div>
                                      {lrmodulewise}

                                    </div> */}

                                    <div className="tab-content" id="room3" >
                                    
                                      <div className="myjourney-tabhead nhead fivecolumns">
                                        <div className="headrow  newhead ">
                                          <div className="col">DLR ID</div>
                                          <div className="col col2">Room Name</div>
                                          <div className="col col3">Module Name</div>

                                          {/* <div className="col col4">PS</div> */}
                                          <div className="col col5">Status</div>
                                        </div>
                                      </div>
                                      <div className="tableshow4 divv" id="div1">
                                        <div className="my-journey-table-content fivecolumns newtb ">
																																							<table  style={{width:'100%'}} className="myjourney-table mytb">
																																							<tbody>
																																							{dlrroomwise}
																																							</tbody>
																																							</table>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <div className="tab-content" id="room4">
                                      <div className="abbrevation">
                                        <ul>

                                          <li><strong>PS</strong> - Performance Score</li>
                                          <li><img src={process.env.PUBLIC_URL+"/images/status-completed.png"} alt="" title="" /> - Completed</li>
                                          <li><img src={process.env.PUBLIC_URL+"/images/status-notcompleted.png"} alt="" title="" /> - In Progress</li>
                                          <li><img src={process.env.PUBLIC_URL+"/images/start-small.png"} alt="" title="" /> - Yet to start</li>
                                        </ul>
                                      </div>
                                      <div className="myjourney-tabhead fivecolumns">
                                        <div className="headrow">
                                          <div className="col">DLR ID</div>
                                          <div className="col col2">DLR Name</div>

                                          <div className="col col4">PS</div>
                                          <div className="col col5">Status</div>
                                        </div>
                                      </div>

																			{dlr_module_list}

                                    </div>
 */}

                          </div>
													</div>

			);

		}
}

export default MyJourneyLists;



// WEBPACK FOOTER //
// ./src/learning_records/MyJourneyLists.js